import { render, staticRenderFns } from "./RiskCard.vue?vue&type=template&id=6ac32568&"
import script from "./RiskCard.vue?vue&type=script&lang=ts&"
export * from "./RiskCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports